import {z} from 'zod';

export const DirectSalesVariantChangeFormSchema = z.object({
  directSaleVariantId: z.string(),
});

export type DirectSalesVariantChangeForm = z.infer<typeof DirectSalesVariantChangeFormSchema>;
